import {
    ApiWrapper,
    CombinedWidgetContent,
    CombinedWidgetType,
    WidgetPresenceResponse,
    WidgetPresenceResponseUserList,
    WidgetQuickSurveyResponse,
    WidgetQuickSurveyResponseUserList,
    WidgetWrapperGeneric,
    jUserLittle,
    WidgetCheckListType,
} from '../../types';
import { OF } from '../../util/network';
import { JBaseApi } from '../base';

export class JWidgetApi extends JBaseApi {
    // @deprecated
    public responseUserList(uri: string, uniqid: string, page: number): Promise<ApiWrapper<jUserLittle[]>> {
        return this.network.post({ o: 'widget', f: 'responseUserList', uri, uniqid, page } as OF);
    }

    public removeWidget({ id, type, uniqid }: { id: number; type: string; uniqid: string }): Promise<ApiWrapper<[]>> {
        return this.network.post({ o: 'widget', f: 'removeWidget', id, type, uniqid } as OF);
    }

    public updateWidget<T = CombinedWidgetType>({
        id,
        uniqid,
        content,
        title,
        type,
        uri,
        v2 = false,
    }: {
        id?: number;
        type?: string;
        uniqid: string;
        content: Partial<CombinedWidgetContent>;
        title?: string;
        uri?: string;
        v2?: boolean;
    }): Promise<ApiWrapper<Pick<WidgetWrapperGeneric<T>, 'widget'>[]>> {
        return this.network.post({ o: 'widget', f: 'updateWidget', uri, id, uniqid, content, title, type, v2 } as OF);
    }

    public getWidget<T = CombinedWidgetType>(
        {
            uri,
            uniqid,
        }: {
            uri: string;
            uniqid: string;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<T>> {
        return this.network.post({ o: 'widget', f: 'getWidget', uri, uniqid } as OF, signal);
    }

    public checkListRespond({
        id,
        type,
        uri,
        idUser,
        uniqid,
        index,
    }: {
        id?: number;
        type?: string;
        uri?: string;
        idUser?: number;
        uniqid: string;
        index: number;
    }): Promise<ApiWrapper<[]>> {
        return this.network.post({ o: 'widget', f: 'checkListRespond', uri, id, type, uniqid, idUser, index } as OF);
    }

    public checkListGetResponse({
        uri,
        uniqid,
    }: {
        uri: string;
        uniqid: string;
    }): Promise<ApiWrapper<WidgetCheckListType>> {
        return this.network.post({ o: 'widget', f: 'checkListGetResponse', uri, uniqid } as OF);
    }

    public presenceRespond(
        {
            id,
            type,
            uri,
            value,
            uniqid,
        }: {
            id?: number;
            type?: string;
            uri?: string;
            value: number;
            uniqid: string;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<[]>> {
        return this.network.post({ o: 'widget', f: 'presenceRespond', uri, id, type, value, uniqid } as OF, signal);
    }

    public presenceCancel(
        {
            uri,
            uniqid,
        }: {
            uri: string;
            uniqid: string;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({ o: 'widget', f: 'presenceCancel', uri, uniqid } as OF, signal);
    }

    public presenceGetResponse(
        {
            uri,
            uniqid,
        }: {
            uri: string;
            uniqid: string;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<WidgetPresenceResponse>> {
        return this.network.post({ o: 'widget', f: 'presenceGetResponse', uri, uniqid } as OF, signal);
    }

    public quickSurveyGetResponse(
        {
            uri,
            uniqid,
        }: {
            uri: string;
            uniqid: string;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<WidgetQuickSurveyResponse>> {
        return this.network.post({ o: 'widget', f: 'quickSurveyGetResponse', uri, uniqid } as OF, signal);
    }

    public quickSurveyAddEnty(
        {
            uri,
            uniqid,
            label,
        }: {
            uri: string;
            uniqid: string;
            label: string;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<boolean>> {
        return this.network.postCSRF({ o: 'widget', f: 'quickSurveyAddEntry', uri, label, uniqid } as OF, signal);
    }

    public quickSurveyRespond(
        {
            id,
            type,
            uri,
            index,
            multi,
            uniqid,
        }: {
            id?: number;
            type?: string;
            uri?: string;
            index: number;
            multi: number;
            uniqid: string;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<[]>> {
        return this.network.postCSRF(
            { o: 'widget', f: 'quickSurveyRespond', id, type, uri, index, multi, uniqid } as OF,
            signal,
        );
    }

    public quickSurveyGetResponseUserList(
        {
            uri,
            uniqid,
            index,
            page,
            limit,
        }: {
            uri: string;
            uniqid: string;
            index: number;
            limit?: number;
            page?: number;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<WidgetQuickSurveyResponseUserList>> {
        return this.network.post(
            { o: 'widget', f: 'quickSurveyGetResponseUserList', uri, uniqid, index, page, limit } as OF,
            signal,
        );
    }

    public presenceGetResponseUserList(
        {
            uri,
            uniqid,
            index,
            page,
            limit,
        }: {
            uri: string;
            uniqid: string;
            index: number;
            limit?: number;
            page?: number;
        },
        signal?: AbortSignal,
    ): Promise<ApiWrapper<WidgetPresenceResponseUserList>> {
        return this.network.post(
            { o: 'widget', f: 'presenceGetResponseUserList', uri, uniqid, index, page, limit } as OF,
            signal,
        );
    }
}
